import { useEffect, useState } from 'react';
import { Api } from '@infra/api';
import { AnalysisContext } from '@domain/models';
import { Modal } from '../components/Modal';
import { DataTable } from '../components/DataTable';

const empty: AnalysisContext = { context_code:'', context_name:'', context_description:'' };

export function ContextsPage() {
  const [items, setItems] = useState<AnalysisContext[]>([]);
  const [form, setForm] = useState<AnalysisContext>({ ...empty });
  const [selected, setSelected] = useState<AnalysisContext & { id: number } | null>(null);

  useEffect(() => {
    Api.listContexts().then(setItems).catch(console.error);
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const created = await Api.createContext(form);
    setItems([created, ...items]);
    setForm({ ...empty });
  }

  async function saveSelected() {
    if (!selected || selected.id == null) return;
    const updated = await Api.updateContext(selected.id, { context_code: selected.context_code!, context_name: selected.context_name!, context_description: selected.context_description! });
    setItems(items.map(c => (c.id === updated.id ? updated : c)));
    setSelected(null);
  }

  return (
    <div>
      <div className="toolbar">
        <div className="title"><h2 style={{margin:0}}>Контексты</h2></div>
      </div>
      <div className="row">
        <form className="card" onSubmit={submit} style={{maxWidth:620}}>
          <h3 style={{marginTop:0}}>Новый контекст</h3>
          <label>Код</label>
          <input value={form.context_code} onChange={e=>setForm({...form, context_code:e.target.value})} required />
          <label>Название</label>
          <input value={form.context_name} onChange={e=>setForm({...form, context_name:e.target.value})} required />
          <label>Описание</label>
          <input value={form.context_description} onChange={e=>setForm({...form, context_description:e.target.value})} required />
          <div style={{marginTop:12}}>
            <button>Создать</button>
          </div>
        </form>

        <div style={{flex:2}}>
          <DataTable
            data={items}
            title="Список"
            searchFields={['context_code', 'context_name', 'context_description']}
            searchPlaceholder="Поиск по коду, названию, описанию..."
            onRowClick={(item) => item.id != null && setSelected(item as AnalysisContext & {id:number})}
            columns={[
              { key: 'context_code', title: 'Код' },
              { key: 'context_name', title: 'Название' },
              { key: 'context_description', title: 'Описание' }
            ]}
          />
        </div>
      </div>

      {selected && (
        <Modal title={`Контекст: ${selected.context_name}`} onClose={()=>setSelected(null)}>
          <div>
            <label>Код</label>
            <input value={selected.context_code ?? ''} onChange={e=>setSelected({...selected!, context_code:e.target.value})} />
            <label>Название</label>
            <input value={selected.context_name ?? ''} onChange={e=>setSelected({...selected!, context_name:e.target.value})} />
            <label>Описание</label>
            <input value={selected.context_description ?? ''} onChange={e=>setSelected({...selected!, context_description:e.target.value})} />
            <div style={{marginTop:12, display:'flex', gap:8}}>
              <button onClick={saveSelected}>Сохранить</button>
              <button className="secondary" onClick={()=>setSelected(null)}>Отмена</button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}


